export default () => {
  const $form = $('.js-register__form')

  if ( !$form.length ) {
    return
  }

  $form.on('submit', submitForm)

  function submitForm(e) {
    e.preventDefault()

    const $titleInput = $('.js-register__form [name="title"]')
    const $emailInput = $('.js-register__form [name="email"]')
    const $firstNameInput = $('.js-register__form [name="first_name"]')
    const $lastnameInput = $('.js-register__form [name="last_name"]')
    const $constentInput = $('.js-register__form [name="agree"]')

    // eslint-disable-next-line
    const url = lrg_login.ajaxurl
        // eslint-disable-next-line
    const nonce = lrg_login.ajaxnonce
    const data = {
      action: 'lrg_member_register',
      nonce_ajax : nonce,
      title: $titleInput.val(),
      email: $emailInput.val(),
      first_name: $firstNameInput.val(),
      last_name: $lastnameInput.val(),
      agreed: $constentInput.val(),
    }

    const $componentWrapper = $('.js-register__leftCol')

    $componentWrapper.addClass('is-loading')
    $componentWrapper.append('<div class="c-register__spinner js-register__spinner l-spinner"><div class="l-spinner__el"></div></div>')

    $.post(url, data, function(response) {
      let errors = ''
      if ( response ) {
        try {
          const respData = JSON.parse(response);
          if ( respData.errors && respData.errors.length ) {
            errors = respData.errors[0]
          }
          console.log(respData.message == 'success')
          if ( errors ) {
            $('.js-register__errorPlaceholder').text(errors)
          } 
          if( respData.message == 'success' ) {
            $('.js-register__formWrapper').html(`
              <div class="c-register__thanks l-box l-box--gold">
                <p>Thank you for registering for GENERAL MEMBERSHIP.</p>
                <p>Keep track on news, insights & invites.</p>
                <p>We couldn't be more excited to have you onboard and look forward to taking you on gourmet adventures with us.</p>
                <p>To also enjoy with exclusive offers join our club.</p>
                <p>The Luxury Restaurant Guide Team</p>
              </div>
            `)
          }

        }
        catch(e) {
          console.log('error', e)
        }
      }
    })
    .always(function() {
      $('.js-register__spinner').remove()
      $componentWrapper.removeClass('is-loading')
    })

  }

}